<template>
  <div class="bg-gray-100 absolute right-5 top-5">
    <ViceButton icon="LogoutIcon" red @click="logout">Log out</ViceButton>
  </div>

  <jet-authentication-card v-if="!isCodeSent">
    <card-header>Verify it's you</card-header>
    <template #logo>
      <jet-authentication-card-logo />
    </template>
    <ul class="mt-4 mb-1 px-6 list-inside text-sm text-red-600" v-if="this.$page.props.error">
      <li>{{ this.$page.props.error }}</li>
    </ul>
    <form
      @submit.prevent="confirmNumber"
      class="px-6 pb-6 pt-6"
      :class="{ 'sm:pt-2': this.$page.props.error }"
    >
      <div v-if="this.$page.props.status" class="mb-4 font-medium text-sm text-vice-teal-600">
        {{ this.$page.props.status }}
      </div>
      <div v-if="!this.$page.props.error" class="mb-3 font-medium text-sm text-gray-400">
        To ensure the security of your account, please provide your phone number and CE will send
        you a verification code.
      </div>
      <div>
        <jet-label for="phone-number" value="Phone number:" />
        <vue-tel-input
          data-cy="verify-phone"
          id="phone-number"
          type="text"
          name="phone_number"
          v-model="formPhone.phone_number"
          ref="phone"
          class="mt-2 h-9 px-0"
          :defaultCountry="'GB'"
          :mode="'international'"
          :ignoredCountries="['RU']"
          :inputOptions="{ showDialCode: true }"
        ></vue-tel-input>
      </div>

      <div class="flex items-center justify-end my-4">
        <jet-button class="w-full flex justify-center">Verify</jet-button>
      </div>
    </form>
  </jet-authentication-card>
  <jet-authentication-card v-else>
    <card-header>Verify it's you</card-header>
    <template #logo>
      <jet-authentication-card-logo />
    </template>

    <ul class="mt-4 px-6 list-inside text-sm text-red-600" v-if="this.$page.props.error">
      <li>{{ this.$page.props.error }}</li>
    </ul>
    <form
      @submit.prevent="submit"
      class="px-6 pb-6 pt-6"
      :class="{ 'sm:pt-0': this.$page.props.error }"
    >
      <div v-if="this.$page.props.status" class="font-medium text-vice-teal-600">
        {{ this.$page.props.status }}
        <br />
        <span class="text-gray-400 tracking-tight text-sm font-medium">
          If you don't receive it within the next 60 seconds via SMS or email, please try resending
          it.
        </span>
      </div>
      <div class="mt-3">
        <jet-input
          id="code"
          type="text"
          name="code"
          placeholder="Enter code here"
          @click.prevent=""
          class="mt-1 block w-full"
          v-model="formCode.code"
          required
          autofocus
          @keydown.enter.prevent
        />
      </div>
      <div class="form-group row mb-0">
        <div class="col-md-8 offset-md-4">
          <button
            class="text-vice-teal-600 text-sm mt-1 ml-0.5 font-medium"
            @click.prevent="handleResend"
          >
            Resend Code
          </button>
        </div>
      </div>
      <div class="flex items-center justify-end my-4 gap-4">
        <jet-button
          v-if="!this.$page.props.user.phone_confirmed"
          class="w-full flex justify-center"
          @click="goBack"
        >
          Back
        </jet-button>
        <jet-button
          class="w-full flex justify-center"
          :class="{ 'opacity-25': formCode.processing }"
          :disabled="formCode.processing"
        >
          Submit
        </jet-button>
      </div>
    </form>
  </jet-authentication-card>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import CardHeader from '@/Components/Cards/CardHeader.vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';

export default {
  components: {
    CardHeader,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetLabel,
    ViceButton,
    VueTelInput,
  },
  props: {
    canResetPassword: Boolean,
    status: String,
  },

  data() {
    console.log(this.$page);
    return {
      responseValidation: {
        error: '',
        status: '',
      },
      isConfirmed: false,
      isResend: false,
      formCode: this.$inertia.form({
        code: '',
      }),
      formPhone: this.$inertia.form({
        phone_number: this.$page.props.user.phone,
      }),
      isCodeSent: this.$page.props.user.phone_confirmed === 1,
    };
  },

  methods: {
    submit() {
      this.resetFeedbackMessages();
      this.formCode
        .transform((data) => ({
          ...data,
          remember: this.formCode.remember ? 'on' : '',
        }))
        .post(this.route('2fa.post'));
    },
    async confirmNumber() {
      this.resetFeedbackMessages();
      try {
        const responseTwoFa = await axios.post(route('api.2fa.resend'), this.formPhone);
        if (responseTwoFa.data.status) {
          this.$page.props.status = `We've ${this.isResend ? 'resent the' : 'sent a'}
    code to ${this.formPhone.phone_number}`;
          this.isCodeSent = true;
        } else {
          this.$page.props.error = responseTwoFa.data.error;
        }
      } catch (error) {
        // Other errors to be handled. Internal server errors among others.
        this.$page.props.error = 'Something went wrong. Try again';
      }
    },

    handleResend() {
      this.confirmNumber();
      this.isResend = true;
    },
    resetFeedbackMessages() {
      this.$page.props.error = '';
      this.$page.props.status = '';
    },
    goBack() {
      this.resetFeedbackMessages();
      this.isCodeSent = false;
    },
    logout() {
      this.$inertia.post(route('clinician.logout'));
    },
  },
  computed: {
    showConfirmation() {
      return this.$page.props.user.phone_confirmed === 0 && !this.isConfirmed;
    },
  },
  watch: {
    'formPhone.phone_number': {
      handler(newVal) {
        if (newVal) this.formPhone.phone_number = this.formPhone.phone_number.replace(/\s+/g, '');
      },
    },
  },
};
</script>
